import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { Network } from '@root/entities/network'

import { ProviderIcon } from './provider-icon'

import type { Provider } from '../model'
import type { ClassNameProps } from '@root/shared/react'

type ProviderTooltipContentProps = {
  provider: Provider.Provider
  network: Network.Network
} & ClassNameProps

export const ProviderTooltipContent: React.FC<ProviderTooltipContentProps> = ({
  className,
  provider,
  network,
}) => {
  const { t } = useTranslation()

  return (
    <Root className={className}>
      <ProviderIcon provider={provider} size={16} />
      <div>
        {t('pool.open-in-explorer', {
          provider: Network.networkToExplorerName(network),
        })}
      </div>
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  gap: 6px;
`
